module.exports = __webpack_public_path__ + "static/img/noJff887f6b.png";